import { EGMButtonTypes, IGMListItem } from "@/shared/types"

import { globalMovement } from "@/gluelayer/core/modules/globalMovement"
import { Button, Input } from "@mui/material"
import { FC, useRef } from "react"
import { EDirection } from "../GlobalMovement"
import "./index.scss"

interface IProps {
  list: IGMListItem[]
  Updata: (
    isPlus: boolean, //差值大于等于0为true，否则为false
    direction: number,
    step: number, //差值
    list: IGMListItem[],
    isUpdate: boolean,
  ) => void
}

const GMButtons: FC<IProps> = ({ list, Updata }) => {
  const MyInputRef = useRef<any>(null)
  const dataRef = useRef<IGMListItem[]>(list)
  const step = 0.25
  const maxValue = 25
  const minValue = -25

  const getDirection = (type: EGMButtonTypes) => {
    switch (type) {
      case EGMButtonTypes.GROUP_1:
        return 0
      case EGMButtonTypes.GROUP_2:
        return 1
      case EGMButtonTypes.GROUP_3:
        return 2
      case EGMButtonTypes.GROUP_4:
        return 3
      case EGMButtonTypes.GROUP_5:
        return 4
      case EGMButtonTypes.GROUP_6:
        return 5
    }
  }

  /**
   * Input Change
   */
  const changeValue = (type: EGMButtonTypes, value: string) => {
    const preValue = list.find((item) => item.type === type)?.value
    const isPlus = Number(value) >= Number(preValue)
    const direction = getDirection(type)
    const newList = list.map((item) => {
      if (item.type !== type) return item

      let numValue = value
      if (Number(numValue) > maxValue) {
        numValue = maxValue.toString()
      } else if (Number(numValue) < minValue) {
        numValue = minValue.toString()
      }

      return {
        ...item,
        value: numValue,
      }
    })
    const curValue = newList.find((item) => item.type === type)?.value
    const stepVal = Number(curValue) - Number(preValue)

    Updata(isPlus, direction, Math.abs(Number(stepVal)), newList, false)
  }

  /**
   * Button Click
   */
  const handleChange = (type: EGMButtonTypes, direction: EDirection) => {
    const isPlus = direction === EDirection.UP
    const newList = list.map((item) => {
      if (item.type === type) {
        let value = Number(item.value)
        if (direction === EDirection.UP) {
          if (value + step <= maxValue) {
            value = value + step
          } else {
            value = maxValue
          }
        } else {
          if (value - step >= minValue) {
            value = value - step
          } else {
            value = minValue
          }
        }
        return {
          ...item,
          value: value.toFixed(2),
        }
      }
      return item
    })
    const myDirection = getDirection(type)

    const stepVal = step
    Updata(isPlus, myDirection, Number(stepVal), newList, true)
  }

  const onFocus = (e, type: EGMButtonTypes) => {
    dataRef.current = list
  }

  /**
   * TextArea onKeyDown
   */
  const onKeyDown = (e, type: EGMButtonTypes) => {
    if (e.keyCode === 27 || e.keyCode === 13) {
      const preValue = dataRef.current.find((item) => item.type === type)?.value

      const isPlus = Number(e.target.value) >= Number(preValue)
      const direction = getDirection(type)

      const newList = dataRef.current.map((item) => {
        if (item.type !== type) return item

        let numValue = e.target.value
        if (Number(numValue) > maxValue) {
          numValue = maxValue.toString()
        } else if (Number(numValue) < minValue) {
          numValue = minValue.toString()
        }

        return {
          ...item,
          value: numValue,
        }
      })
      const curValue = newList.find((item) => item.type === type)?.value
      const stepVal = Number(curValue) - Number(preValue)
      const isFlag = true
      if (isFlag) {
        globalMovement.SetControllArchMove(
          isPlus,
          direction,
          Math.abs(Number(stepVal)) || 0,
        )
        dataRef.current = newList
        MyInputRef.current?.blur()
      } else {
        MyInputRef.current?.blur()
      }
    }
  }

  return (
    <div className="gm-container">
      <div className="gm-header">
        <div className="common-style">( - )</div>
        <div className="common-style">( + )</div>
      </div>
      <div className="gm-buttons">
        {list.map((item) => (
          <div key={item.type} className="gm-button-item">
            <Button
              className="btn btn-secondary"
              variant="contained"
              onClick={() => handleChange(item.type, EDirection.DOWN)}
            >
              {item.iconLeft}
            </Button>
            <div className="input-wrap">
              <Input
                inputRef={MyInputRef}
                value={item.value}
                type="number"
                disableUnderline={true}
                onChange={(e: any) => {
                  const value = e.target.value
                  const splitValue = value.split(".")
                  if (splitValue.length > 1 && splitValue[1].length > 2) {
                    return
                  }

                  changeValue(item.type, value)
                }}
                onFocus={(e) => onFocus(e, item.type)}
                onKeyDown={(e) => onKeyDown(e, item.type)}
              />
              <div className="input-value-unit">{item.unit}</div>
            </div>
            <Button
              className="btn btn-secondary"
              variant="contained"
              onClick={() => handleChange(item.type, EDirection.UP)}
            >
              {item.iconRight}
            </Button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GMButtons
